import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
interface ParallaxImageProps {
  src: string;
  alt: string;
  className?: string;
  imageClassName?: string;
  overlay?: React.ReactNode;
}
export function ParallaxImage({
  src,
  alt,
  className = '',
  imageClassName = '',
  overlay
}: ParallaxImageProps) {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['-15%', '15%']);
  return <div ref={ref} className={`relative overflow-hidden ${className}`} data-id="element-244">
      <motion.img src={src} alt={alt} style={{
      y,
      scale: 1.15
    }} className={`absolute inset-0 w-full h-full object-cover ${imageClassName}`} data-id="element-245" />
      {overlay && <div className="absolute inset-0" data-id="element-246">{overlay}</div>}
    </div>;
}